import React from 'react';
import { Col, Card, Row, Image } from "react-bootstrap"; // Added Image import
import PauloPfp from '../../../assets/icons/PauloPfp.svg';

const Teamsb2b = () => (
    <Col className='col-4'>
        <style>
            {`
            .scrollable-container {
                overflow-y: auto;
                height: calc(100% - 3rem);
                margin-top: 10px;
            }
            
            ::-webkit-scrollbar {
                width: 8px;
            }
            
            ::-webkit-scrollbar-thumb {
                background-color: rgba(255, 255, 255, 0.65);
                border-radius: 10px;
            }
            
            ::-webkit-scrollbar-track {
                background-color: #17296B;
                border-radius: 10px;
            }
            `}
        </style>
        <Card className='rounded-4 shadow' style={{ backgroundColor: "#17296B", height: "100%" }}>
            <div className='m-2' style={{ height: "100%" }}>
                <Row className='border-bottom' style={{width: '100%', margin: '0 auto'}}>
                    <Col className='d-flex justify-content-start align-items-center gap-1 pb-2 text-white'>
                        <b className='ms-3' style={{ fontSize: "2.5vmin" }}>Equipas</b>
                    </Col>
                </Row>
                <div className="scrollable-container" style={{ overflowX: "hidden" }}>
                    <Row className='d-flex justify-content-center flex-column mt-1 gap-1 text-white'>
                        {['COpE', 'Aveiro Delegation', 'SKAO', 'Azores Delegation'].map((team, index) => (
                            <Col key={index} className='col-12 mx-2'>
                                <Image src={PauloPfp} roundedCircle style={{ width: '2vw', height: '2vw', minWidth: '20px', minHeight: '20px' }} />
                                <b className='ms-3 fw-medium' style={{ fontSize: "2vmin" }}>{team}</b>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </Card>
    </Col>
);

export default Teamsb2b;
